var chapterNavigationSlides = ['I1', 'I3', 'I5', 'I7', 'I9', 'V1'];
var chapterCompletionSlides = ['I2', 'I4', 'I6', 'I8', 'I9', 'V4'];

/**
 *
 */
function initSideMenu() {
	var $menu = $('#si-side-menu');
	var $container = $('#si-side-menu-container');
	var buttons = $('.si-menu-navigation').find('button');

	$menu.on('click.stop', function (e) {
		e.stopPropagation();
	});
	$container.on('click.side', function (e) {
		closeSideMenu();
	});

	buttons.each(function (idx, button) {
		$(button).on('click.side', function () {
			var id = chapterNavigationSlides[idx];
			jumpToId(id);
			closeSideMenu();
		});
	});
}

/**
 *
 */
function openSideMenu() {
	var $menu = $('#si-side-menu');
	var $container = $('#si-side-menu-container');

	$container.addClass('menu-open');
	$menu.addClass('menu-open');
	// this is for pausing the video when you open the side menu
	var type = slides[globalVar.curSlide].type;
	if (slides[globalVar.curSlide].videoLoaded && type == 'video') {
		videojs(globalVar.$curSlide.find('video')[0].id).pause();
	}

	handleSideButtons();
}

/**
 *
 */
function closeSideMenu() {
	var $menu = $('#si-side-menu');
	var $container = $('#si-side-menu-container');

	$container.removeClass('menu-open');
	$menu.removeClass('menu-open');
	// unpause the video when you close the side menu
	var type = slides[globalVar.curSlide].type;
	if (slides[globalVar.curSlide].videoLoaded && type == 'video') {
		if (videojs(globalVar.$curSlide.find('video')[0].id).paused()) {
			videojs(globalVar.$curSlide.find('video')[0].id).play();
		}
	}
}

/**
 *
 */
function handleSideButtons() {
	var buttons = $('.si-menu-navigation').find('button');
	var checks = $('.si-menu-checks__js');

	lock($(buttons));
	unlock($(buttons[0]));
	buttons.each(function (idx, button) {
		if (slideCompletion[chapterCompletionSlides[idx]]) {
			$(checks[idx]).addClass('completed');
			if (buttons[idx + 1]) {
				unlock($(buttons[idx + 1]));
			}
		}
	});
}
